export default "__VITE_ASSET__D9Yj7Pad__"